var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfiledark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20 5.81V14.19C20 17 18.71 18.93 16.44 19.66C15.78 19.89 15.02 20 14.19 20H5.81C4.98 20 4.22 19.89 3.56 19.66C1.29 18.93 0 17 0 14.19V5.81C0 2.17 2.17 0 5.81 0H14.19C17.83 0 20 2.17 20 5.81Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfiledark);
export default __webpack_public_path__ + "static/media/profiledark.ea8eb828f9e9fc7456270f8932692b92.svg";
export { ForwardRef as ReactComponent };